import dayjs, { Dayjs } from "dayjs";

import { IHotelSearchResponse, IHotelsResult, IHotelInfoResult } from "types";

import { dataForSeoInstance } from "./instances";

type ListRequest = {
  checkIn: Dayjs;
  checkOut: Dayjs;
  placeName: string;
  country: string;
};

export const list = ({
  checkIn,
  country,
  checkOut,
  placeName,
}: ListRequest) => {
  const data = [
    {
      location_name: country,
      language_name: "English",
      keyword: encodeURI(`hotels at ${placeName}`),
      check_in: dayjs(checkIn).format("YYYY-MM-DD"),
      check_out: dayjs(checkOut).format("YYYY-MM-DD"),
      currency: "USD",
      adults: 1,
      sort_by: "best_match",
    },
  ];

  return dataForSeoInstance.post<IHotelSearchResponse<IHotelsResult>>(
    "/business_data/google/hotel_searches/live",
    data
  );
};

type InfoRequest = {
  country: string;
  hotelID: string;
  checkIn: Dayjs;
  checkOut: Dayjs;
};

export const info = ({ country, checkIn, checkOut, hotelID }: InfoRequest) => {
  const data = [
    {
      location_name: country,
      language_name: "English",
      hotel_identifier: encodeURI(hotelID),
      check_in: dayjs(checkIn).format("YYYY-MM-DD"),
      check_out: dayjs(checkOut).format("YYYY-MM-DD"),
    },
  ];

  return dataForSeoInstance.post<IHotelSearchResponse<IHotelInfoResult>>(
    "/business_data/google/hotel_info/live/advanced",
    data
  );
};
